<div class="wopi-optin-dialog">
    <sync-dialog [config]="{
        title: 'View preferences',
        isClosable: false,
      actionButton: 'Use Office',
      cancelButton: 'Keep using Sync',
      onCancelClick: optout,
      onActionClick: optin,
      closeButtonType:'outlined'
      }" [isFullScreen]="false" [open]="openWopiOptinDialog">
        <div class="wopi-optin-dialog-container">
            <div class="body-1 text">
                You can now use Office Online to better integrate your workflow within Sync.
                Edit and view Microsoft Word documents, Excel spreadsheets and Powerpoint slideshows all from your web
                panel.
            </div>
            <div class="image-container">
                <img src="assets/images/ms-office-integration.svg" alt="sync office integration">
            </div>
            <div class="caption subtext">
                View the <a href="https://www.sync.com/help/office-online">Sync + Office Online documentation</a> for
                more more information.
            </div>
        </div>
    </sync-dialog>
</div>